import { render, staticRenderFns } from "./Error404.html?vue&type=template&id=31d54389&external"
import script from "./Error404.ts?vue&type=script&lang=ts&external"
export * from "./Error404.ts?vue&type=script&lang=ts&external"
import style0 from "./Error404.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports